import { FC, ReactNode } from "react";
import { cn } from "@racoon/ui";

/** Bordered, horizontally scrolling box the location card's tables sit in. */
export const LocationTableFrame: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="w-full overflow-x-auto min-w-0 border rounded-lg">{children}</div>
);

/** A table's empty-state row content. */
export const TableEmpty: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="p-8 text-center text-muted-foreground">{children}</div>
);

/** Shown above a tab's tables while the location is not saved and has no id yet. */
export const SaveLocationFirst: FC<{ className?: string; children: ReactNode }> = ({
  className,
  children,
}) => <div className={cn("text-center text-sm text-gray-500 shrink-0", className)}>{children}</div>;
